﻿$.fn.dxCtrlGridComDestinataireTrackingClickEmail = function custom_dxCtrlGridComDestinataireTrackingClickEmail(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlgridcomdestinatairetrackingclickemail dx-ctrl");
        this.createInstance(new cdxCtrlGridComDestinataireTrackingClickEmail(this, option));
    }
    return this;
}

window.cdxCtrlGridComDestinataireTrackingClickEmail = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.context_grid == 'undefined') option.context_grid = "gridtrackingclickemail"
    if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid] == "undefined") option.bddCtrl.utiCourantParaJson[option.context_grid] = {}

    var dxGrid = null
    function mConstruit() {
        container.empty();

        container.css("height", "100%")

        var lstField = mGetLstField()
        var opt = {
            bddCtrl: option.bddCtrl,
            noDataText: "Aucun tracking click email",
            typeData: "trackingclickemail",
            lstTypeGrille: ["Lignes"],
            context_grid: option.context_grid,
            lstLstConditionBase: mGetLstLstConditionBase(),
            getItemTemplateHeight: function (typeGrille) { return 35 },
            onClickDataGrid: function (container, dataGrid, dataTemplate) {
                if (typeof dataTemplate.strcon == 'undefined') {
                    //pas de strcon, on affiche le mail
                    if (typeof dataTemplate.com_email_envoi != 'undefined') {
                        option.bddCtrl.getObjet("com_email_envoi", dataTemplate.com_email_envoi.id_com_email_envoi).mShowPopup()
                    } else {
                        mTraiteMessageJs("messagejs", "Erreur click sur trackingclick " + JSON.stringify(dataTemplate), $(location).attr("href"), 0, null, null, "orange")
                    }
                } else {
                    //on affiche le strcon
                    var table = option.bddCtrl.table.mGetItem(dataTemplate.strcon.id_table)
                    option.bddCtrl.getObjet(table.nom, dataTemplate.strcon.id).mShowPopup()
                }
            },
            itemsToolbar: mGetLstButtonToolBar(),
            itemsToolbarSelect: mGetLstButtonToolBarSelect,
            //onShowHideCheck: function (showed) {
            //    if (showed) {
            //        if (dxBtAddDossier) dxBtAddDossier.element().closest(".dx-toolbar-button").show()
            //        if (dxBtAddPipeline) dxBtAddPipeline.element().closest(".dx-toolbar-button").show()
            //        if (dxBtDonwload) dxBtDonwload.element().closest(".dx-toolbar-button").show()
            //    } else {
            //        if (dxBtAddDossier) dxBtAddDossier.element().closest(".dx-toolbar-button").hide()
            //        if (dxBtAddPipeline) dxBtAddPipeline.element().closest(".dx-toolbar-button").hide()
            //        if (dxBtDonwload) dxBtDonwload.element().closest(".dx-toolbar-button").hide()
            //    }
            //},
            onSelectionChanged: function () {
                //if (dxBtAddDossier) {
                //    dxBtAddDossier.option("disabled", dxGrid.mGetLstSelectedData().length == 0)
                //    dxBtAddDossier.mRempliCompteur(dxGrid.mGetLstSelectedData().length)
                //}
                //if (dxBtAddPipeline) {
                //    dxBtAddPipeline.option("disabled", dxGrid.mGetLstSelectedData().length == 0)
                //    dxBtAddPipeline.mRempliCompteur(dxGrid.mGetLstSelectedData().length)
                //}
                //if (dxBtDonwload) {
                //    dxBtDonwload.option("disabled", dxGrid.mGetLstSelectedData().length == 0)
                //    dxBtDonwload.mRempliCompteur(dxGrid.mGetLstSelectedData().length)
                //}
                if (typeof option.onSelectionChanged != 'undefined') option.onSelectionChanged()
            },
            onDisplayButtonLigne: mGetLstButtonLigne,
            itemTemplateGrille: itemTemplateGrille,
            itemTemplateGrillePlus: itemTemplateGrillePlus,
            onEndClickDataGrid: option.onEndClickDataGrid,
            fields: lstField,
            allowCarto: false,
            allowFilter: true,
            allowLucene: true,
            allowCheck: option.allowCheck,
            allowToolbar: option.allowToolbar,
            allowDeleteInToolbar: false,
            showColumnHeaders: option.showColumnHeaders,
            lstIdTableIdExclu: option.lstIdTableIdExclu,
            lstIdTableIdInclu: option.lstIdTableIdInclu
        }

        dxGrid = $("<div/>").appendTo(container).dxCtrlVirtualGrid(opt).dxCtrlVirtualGrid("instance")
    }

    function itemTemplateGrille(contentElement, dataTemplate, type) {
        itemTemplateGrilleClickVue(contentElement, dataTemplate, type, dxGrid, { bddCtrl: option.bddCtrl, showCom: option.showVoirDoc, showStrcon: true })
        //var $Table = $("<table style='width:100%;height:100%;table-layout:fixed;text-align:left;'/>").appendTo(contentElement)
        //var $Tr = $("<tr/>").appendTo($Table)
        //var $TdUtiTrack = $("<td style='width:20px;padding:0 3px;'/>").appendTo($Tr)
        //$("<div style='width:18px;height:18px;border-radius:50%;'/>").appendTo($TdUtiTrack).dxCtrlImgStrConUti({
        //    bddCtrl: option.bddCtrl,
        //    idTable: option.bddCtrl.getObjet("utilisateur").mGetTable().id_table,
        //    id: dataTemplate.com_email_envoi.id_utilisateur,
        //    text: option.bddCtrl.getObjet("utilisateur", dataTemplate.com_email_envoi.id_utilisateur).mGetLib1()
        //})
        //var txt = ""
        //if (dataTemplate.com_email_envoi_lien.libelle && dataTemplate.com_email_envoi_lien.libelle.length > 0) txt = dataTemplate.com_email_envoi_lien.libelle
        //var $TdLien = $("<td style='width:34%;max-width:150px;padding:0 5px;font-family:barlow condensed;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;' class='state-hover2'></td>").appendTo($Tr)
        //$TdLien.attr("title", ((txt.length > 0) ? "(" + txt + ")<br/>" : "") + "<u>" + dataTemplate.com_email_envoi_lien.lien + "</u>")
        //var $span = $("<span></span>").appendTo($TdLien)
        //if (txt.length>0) $span.text("(" + txt + ") ")
        //$("<a href='javascript:void(0)'>" + dataTemplate.com_email_envoi_lien.lien.reduit(20) + "</a>").appendTo($span)
        //$TdLien.on("click", function (e) { e.stopPropagation(); window.open(dataTemplate.com_email_envoi_lien.lien, "_blank") })

        //var $TdCom = $("<td style='padding:0 5px;width:33%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-style:italic;' class='state-hover2'/>").appendTo($Tr)
        //$TdCom.text(dataTemplate.com_email_envoi.objet)
        //$TdCom.attr("title", "Afficher l'email<br/>" + dataTemplate.com_email_envoi.objet)
        //$TdCom.on("click", function (e) { e.stopPropagation(); option.bddCtrl.getObjet("com_email_envoi", dataTemplate.com_email_envoi.id_com_email_envoi).mShowPopup() })

        //var $TdStrCon = $("<td style='padding:0 5px;width:33%;'/>").appendTo($Tr)
        //if (typeof dataTemplate.strcon == "undefined") {
        //    $TdStrCon.html("<span style='opacity:0.3;'>Aucune fiche pour l'adresse email</span>")
        //} else {
        //    $TdStrCon.addClass('state-hover2')
        //    var table = option.bddCtrl.table.mGetItem(dataTemplate.strcon.id_table_key)
        //    var obj = option.bddCtrl.getObjet(table.nom)
        //    var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo($TdStrCon)
        //    var $Tr = $("<tr/>").appendTo($Table)
        //    var $TdICone = $("<td style='width:20px;padding:0 3px;'/>").appendTo($Tr)
        //    obj.mGetIcone(dataTemplate.strcon).appendTo($TdICone)
        //    var $TdImage = $("<td style='width:20px;padding:0 3px;'/>").appendTo($Tr)
        //    $("<div style='width:18px;height:18px;border-radius:50%;'/>").appendTo($TdImage).dxCtrlImgStrConUti({
        //        bddCtrl: option.bddCtrl,
        //        idTable: table.id_table,
        //        id: dataTemplate.strcon.id_key,
        //        text: ""
        //    })
        //    var $TdLib = $("<td style='width:100%;padding:0 3px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:bold;'/>").appendTo($Tr)
        //    $TdLib.text(obj.objetMetier.mGetLibNomPrenomFromDataTemplate(dataTemplate.strcon))
        //    $TdStrCon.attr("title", "Ouvrir la fiche<br/>" + obj.objetMetier.mGetLibNomPrenomFromDataTemplate(dataTemplate.strcon))
        //    $TdStrCon.on("click", function (e) { e.stopPropagation(); option.bddCtrl.getObjet(table.nom, dataTemplate.strcon.id_key).mShowPopup() })
        //}
        ////var $Table = $("<table style='width:100%;height:100%;'/>").appendTo(contentElement)
        ////var $Tr = $("<tr/>").appendTo($Table)
        ////var $TdStrCon = $("<td style='width:100%;text-align:left;'/>").appendTo($Tr)
        ////var $TdUtiTrack = $("<td style='width:30px;padding:0 3px;'/>").appendTo($Tr)
        ////$("<div style='width:24px;height:24px;border-radius:50%;'/>").appendTo($TdUtiTrack).dxCtrlImgStrConUti({
        ////    bddCtrl: option.bddCtrl,
        ////    idTable: option.bddCtrl.getObjet("utilisateur").mGetTable().id_table,
        ////    id: dataTemplate.com_email_envoi.id_utilisateur,
        ////    text: option.bddCtrl.getObjet("utilisateur", dataTemplate.com_email_envoi.id_utilisateur).mGetLib1()
        ////})
        ////var $TdAdresseEmail = $("<td style='width:1px;padding:0 3px;white-space:nowrap;font-family:barlow condensed;' title='" + dataTemplate.com_destinataire.adresse_email + "'><u>" + dataTemplate.com_destinataire.adresse_email.reduit(20) + "</u></td>").appendTo($Tr)

        ////if (typeof dataTemplate.strcon == "undefined") {
        ////    $TdStrCon.html("<span style='opacity:0.3;'>Aucune fiche pour l'adresse email</span>")
        ////} else {
        ////    var table = option.bddCtrl.table.mGetItem(dataTemplate.strcon.id_table_key)
        ////    var obj = option.bddCtrl.getObjet(table.nom)
        ////    obj.itemTemplateGrille($TdStrCon, dataTemplate.strcon, type)
        ////}
    }
    function itemTemplateGrillePlus(contentElement, dataTemplate) {
        var $Span = $("<span style=''><i class='fas fa-arrow-pointer dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataTemplate.track.dcr.toDateIlya(true) + "</span>").appendTo(contentElement)
        $Span.attr("title", dataTemplate.track.dcr.toFrenchDateTime())

        //var $Span = $("<span style='font-family:barlow condensed;'></span>").appendTo(contentElement)
        //var $ADoc = null

        //if (option.showVoirDoc) {
        //    $ADoc = $("<span><a href='javascript:void(0)'>Voir email</a> &bull; </span>").appendTo($Span)
        //    $ADoc.on("click", function (e) {
        //        e.stopPropagation()
        //        option.bddCtrl.getObjet("com_email_envoi", dataTemplate.com_email_envoi.id_com_email_envoi).mShowPopup()
        //    })
        //}

        ////if (dataGrid.passe2 == "0") $("<span> &bull; CLICK ROBOT &bull; </span>").appendTo($Span)
        //var $span = $("<span style='font-family:barlow condensed;'>" + ((dataTemplate.com_email_envoi_lien.libelle != null && dataTemplate.com_email_envoi_lien.libelle.length > 0 && dataTemplate.com_email_envoi_lien.libelle != dataTemplate.com_email_envoi_lien.lien) ? "(" + dataTemplate.com_email_envoi_lien.libelle + ") " : "") + "</span>").appendTo(contentElement)
        //var $A = $("<a href='javascript:void(0)'>" + dataTemplate.com_email_envoi_lien.lien.reduit(20) + "</a>").appendTo($span)
        //$A.attr("title", dataTemplate.com_email_envoi_lien.lien)
        //$A.on("click", function (e) {
        //    e.stopPropagation()
        //    window.open(dataTemplate.com_email_envoi_lien.lien, "_blank")
        //})
        //$("<span title='" + dataTemplate.com_email_envoi_tracking_click.dcr.toFrenchDateTime() + "'>  &bull; Click " + dataTemplate.com_email_envoi_tracking_click.dcr.toDateIlya(false) + "" + ((dataTemplate.com_email_envoi_tracking_click.is_robot == "1") ? " &bull; <i class='fas fa-robot'></i> ROBOT" : "") + "</span>").appendTo($span)
    }

    function mGetLstField() {
        var lst = []
        lst = lst.concat([{
            name: "dcr",
            dataField: "dcr",
            caption: "Date click",
            icon: "fas fa-clock",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            groupIndex: 0,
            sortOrder: "desc",
            dataType: "date",
            filterProperty: {
                filterOperations: ["=", "<>", "<", ">", "<=", ">=", "between", "isblank", "isnotblank", "superieurouegaletoday", "inferieurouegaletoday"]
            },
            calculateGroupValue: function (rowData) {
                return rowData.dcr.toGrpDate().id
            },
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-clock-rotate-left dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Click: " + options.data.key.getGroupDateLibelle() + " (" + tot + ")")
            },
            filterLinkGrp: "dcr_tri"
        }, {
            name: "dcr_tri",
            dataField: "dcr_tri",
            allowGrid: true,
            visible: false
        }])
        lst = lst.concat([{
            name: "id_utilisateur",
            dataField: "id_utilisateur",
            caption: "Utilisateur",
            icon: "fas fa-user",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "number",
            calculateGroupValue: function (rowData) {
                return option.bddCtrl.getObjet("utilisateur", rowData.id_utilisateur).mGetLib1()
            },
            groupCellTemplate: function (columnElement, options) {
                var txt = options.data.key
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-user dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + ((txt.length == 0) ? "(Aucun utilisateur)" : txt) + " (" + tot + ")")
            },
            calculateCellValue: function (rowData) {
                return rowData.id_utilisateur
            },
            calculateSortValue: function (rowData) {
                return option.bddCtrl.getObjet("utilisateur", rowData.id_utilisateur).mGetLib1()
            },
            filterProperty: {
                lookup: option.bddCtrl.getObjet("utilisateur").objetMetier.mGetLookUpForFilterBuilder(),
                filterOperations: ["parmi", "notparmi"]
            }
        }, {
            name: "id_com_email_envoi",
            dataField: "id_com_email_envoi",
            caption: "id_com_email_envoi",
            icon: "fas fa-plus",
            allowFilter: false,
            allowGrid: false,
            allowGrouping: false,
            allowSorting: false,
            dataType: "number"
        }, {
            name: "objet",
            dataField: "objet",
            caption: "Objet du mail",
            icon: "fas fa-heading",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: false,
            allowSorting: true,
            dataType: "string",
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-home dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Objet: " +
                    options.displayValue +
                    " (" + tot + ")")
            }
        }, {
            name: "lien",
            dataField: "lien",
            caption: "Lien",
            icon: "fas fa-link",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "string",
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-home dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Lien: " +
                    options.displayValue +
                    " (" + tot + ")")
            }
        }, {
            name: "libelle",
            dataField: "libelle",
            caption: "Libellé lien",
            icon: "fas fa-link",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "string",
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-home dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Libellé lien: " +
                    options.displayValue +
                    " (" + tot + ")")
            }
        }, {
            name: "adresse_email",
            dataField: "adresse_email",
            caption: "Destinataire",
            icon: "fas fa-user",
            allowFilter: false,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: false,
            dataType: "string",
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-home dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Destinataire: " +
                    options.displayValue +
                    " (" + tot + ")")
            }
        }, {
            name: "is_robot",
            dataField: "is_robot",
            caption: "Click robot",
            icon: "fas fa-robot",
            allowFilter: false,
            allowGrid: false,
            allowGrouping: false,
            allowSorting: false,
            dataType: "boolean",
            filterProperty: {
                falseText: "EST UN HUMAIN",
                trueText: "EST UN ROBOT"
            },
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-robot dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + ((options.displayValue == "1") ? "EST UN ROBOT" : "EST UN HUMAIN") + " (" + tot + ")")
            }
        }])

        return lst
    }

    function mGetLstButtonToolBar() {
        var items = []

        //if (typeof option.showBtNew == 'undefined' || option.showBtNew) {
        //    items.push({
        //        location: 'before',
        //        template: function (itemData, itemIndex, itemElement) {
        //            $("<div/>").appendTo(itemElement).dxCtrlButton({
        //                icon: "fas fa-envelope",
        //                icon2: "fas fa-certificate",
        //                colorIcone2: theme.colorBtIcon2,
        //                opacityIcone2: "0.9",
        //                txtTooltip: "Nouvel email",
        //                onClick: function (e) {
        //                    option.bddCtrl.getObjet("com_email_envoi").objetMetier.mShowNewEmail()
        //                }
        //            }).dxCtrlButton("instance")
        //        }
        //    })
        //    items.push({
        //        location: 'before',
        //        template: function (itemData, itemIndex, itemElement) {
        //            $("<div/>").appendTo(itemElement).dxCtrlButton({
        //                icon: "fas fa-square-envelope",
        //                icon2: "fas fa-certificate",
        //                colorIcone2: theme.colorBtIcon2,
        //                opacityIcone2: "0.9",
        //                txtTooltip: "Nouvel emailing",
        //                onClick: function (e) {
        //                    option.bddCtrl.getObjet("com_email_envoi").objetMetier.mShowNewEmail(true)
        //                }
        //            }).dxCtrlButton("instance")
        //        }
        //    })
        //    items.push({
        //        location: 'before',
        //        template: function (itemData, itemIndex, itemElement) {
        //            dxBtNewDocEmail = $("<div/>").appendTo(itemElement).dxCtrlButton({
        //                icon: "fas fa-file",
        //                icon2: "fas fa-certificate",
        //                colorIcone2: theme.colorBtIcon2,
        //                opacityIcone2: "0.9",
        //                icon3: "fas fa-at",
        //                colorIcone3: theme.color,
        //                leftIcone3: true,
        //                txtTooltip: "Nouveau document email",
        //                onClick: function (e) {
        //                    (new cObjetFichierEmlzMetier(null, option.bddCtrl)).mShowNewDocumentEmail()
        //                }
        //            }).dxCtrlButton("instance")
        //        }
        //    })
        //}
        //if (typeof option.showBtTraitement == 'undefined' || option.showBtTraitement) {
        //    if (option.bddCtrl.objCptCli.objetMetier.hasDossier()) {
        //        items.push(option.bddCtrl.getObjet("dossier").objetMetier.mGetButtonToolBarAddDansDossier(function () { return dxGrid }, "select distinct com_destinataire.id_table_destinataire as id_table,com_destinataire.id_destinataire as id from com_email_envoi_tracking_click inner join (select value as id from string_split('%lstid%',',')) as tab ON com_email_envoi_tracking_click.id_com_email_envoi_tracking_click=tab.id INNER JOIN com_destinataire ON com_email_envoi_tracking_click.id_com_destinataire=com_destinataire.id_com_destinataire where not com_destinataire.id_destinataire is null"))
        //    }
        //    if (option.bddCtrl.objCptCli.objetMetier.hasPipeline()) {
        //        items.push(option.bddCtrl.getObjet("pipeline").objetMetier.mGetButtonToolBarAddDansPipeline(function () { return dxGrid }, "select distinct com_destinataire.id_table_destinataire as id_table,com_destinataire.id_destinataire as id from com_email_envoi_tracking_click inner join (select value as id from string_split('%lstid%',',')) as tab ON com_email_envoi_tracking_click.id_com_email_envoi_tracking_click=tab.id INNER JOIN com_destinataire ON com_email_envoi_tracking_click.id_com_destinataire=com_destinataire.id_com_destinataire where not com_destinataire.id_destinataire is null"))
        //        items.push(getToolbarSeparator("before", "auto"))
        //    }

        //    items.push({
        //        location: 'before',
        //        template: function (itemData, itemIndex, itemElement) {
        //            dxBtDonwload = $("<div/>").appendTo(itemElement).dxCtrlButton({
        //                icon: "fas fa-cloud-arrow-up",
        //                txtTooltip: "Exporter la liste des contacts qui ont cliqués",
        //                onClick: function (e) {
        //                    var lstDataTraitement = dxGrid.mGetLstSelectedData()
        //                    if (lstDataTraitement.length == 0) lstDataTraitement = dxGrid.mGetLstData()
        //                    if (lstDataTraitement.length == 0) {
        //                        mNotify("Aucune donnée à exporter.", "warning", 6000)
        //                    } else {
        //                        jaugeDemarrage.mShow()
        //                        var lstIdTableId = []
        //                        lstDataTraitement.forEach(function (data) {
        //                            lstIdTableId.push({ id: data.id })
        //                        })
        //                        option.bddCtrl.mAjaxCall({
        //                            command: "exportstrconclickemail",
        //                            data: lstDataTraitement
        //                        }, function (data) {
        //                            if (data.urlfile.startsWith("~")) data.urlfile = data.urlfile.substring(1)
        //                            window.open(data.urlfile)
        //                            jaugeDemarrage.mHide()
        //                            mNotify("Votre exportation est fini. Le fichier est en cours de téléchargement.", "success", 6000)
        //                        })
        //                    }
        //                }
        //            }).dxCtrlButton("instance")
        //        }
        //    })
        //}

        if (option.bddCtrl.utiCourantParaJson[option.context_grid].show_robot == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid].show_robot = false
        items.push({
            location: 'before',
            template: function (itemData, itemIndex, itemElement) {
                var $Table = $("<table/>").appendTo(itemElement)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:1px;font-size:200%;'><i class='fafa fafa-robot-vueclick'</i></td>").appendTo($Tr)
                //$img = $("<img style='height:20px;'/>").appendTo($Td)
                //$img.attr("src", 'data:image/svg+xml,<svg fill="' + theme.color + '" width="800px" height="800px" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M39 2.03125C38.738281 2.0625 38.503906 2.199219 38.34375 2.40625L35.34375 6.21875C34.78125 5.488281 33.898438 5 32.90625 5L30.09375 5C28.394531 5 27 6.394531 27 8.09375L27 15.90625C27 17.605469 28.394531 19 30.09375 19L32.90625 19C33.898438 19 34.78125 18.511719 35.34375 17.78125L38.34375 21.59375C38.636719 21.960938 39.148438 22.066406 39.5625 21.84375L49.46875 16.4375C49.882813 16.214844 50.074219 15.730469 49.929688 15.285156C49.78125 14.835938 49.339844 14.5625 48.875 14.625C48.753906 14.644531 48.636719 14.6875 48.53125 14.75L39.375 19.78125L36 15.5L36 8.53125L39.375 4.25L48.53125 9.25C48.835938 9.457031 49.230469 9.472656 49.550781 9.292969C49.871094 9.113281 50.0625 8.769531 50.042969 8.402344C50.027344 8.035156 49.804688 7.710938 49.46875 7.5625L39.5625 2.15625C39.390625 2.058594 39.195313 2.015625 39 2.03125 Z M 9 3C4.039063 3 0 7.039063 0 12C0 16.960938 4.039063 21 9 21C13.960938 21 18 16.960938 18 12C18 7.039063 13.960938 3 9 3 Z M 18.6875 7C19.480469 8.519531 20 10.171875 20 12C20 13.828125 19.480469 16.480469 18.6875 18L24.96875 18C24.894531 17.652344 24.90625 16.367188 24.90625 16L24.90625 8C24.90625 7.632813 24.894531 7.347656 24.96875 7 Z M 9 7.34375C11.558594 7.34375 13.65625 9.441406 13.65625 12C13.65625 14.558594 11.558594 16.65625 9 16.65625C6.441406 16.65625 4.34375 14.558594 4.34375 12C4.34375 9.441406 6.441406 7.34375 9 7.34375 Z M 17.8125 18.5625C15.804688 21.242188 12.601563 23 9 23C7.773438 23 6.601563 22.777344 5.5 22.40625L14.28125 38.96875L29.34375 38.96875 Z M 6.875 41C5.253906 41 4 42.316406 4 44L4 49C4 49.582031 4.417969 50 5 50L39 50C39.582031 50 40 49.582031 40 49L40 44C40 42.316406 38.746094 41 37.125 41Z"/></svg>')
                var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxSwitch({
                    focusStateEnabled: false,
                    value: option.bddCtrl.utiCourantParaJson[option.context_grid].show_robot,
                    switchedOffText: "",
                    switchedOnText: "",
                    onValueChanged: function (e) {
                        option.bddCtrl.utiCourantParaJson[option.context_grid].show_robot = e.value
                        option.bddCtrl.mSaveParaJsonUtilisateur();
                        conditionBaseRobot = ((e.value) ? null : { nom_champ: "is_robot", ope: "=", valeur: [{ value: "0" }] })
                        dxGrid.option("lstLstConditionBase", mGetLstLstConditionBase())
                        dxGrid.mReloadData()
                    }
                })
                itemElement.attr("title", "Afficher/cacher<br/>les vues des robots")
            }
        })
        //items.push(getToolbarSeparator("before", "auto"))

        return items
    }

    //var dxBtAddDossier = null
    //var dxBtAddPipeline = null
    //var dxBtDonwload = null
    function mGetLstButtonToolBarSelect(dxVirtualGrid) {
        var items = []
        var itemToolbar = {
            location: 'before',
            visible: (dxVirtualGrid && dxVirtualGrid.toolbarSelectIsVisible),
            template: function (itemData, itemIndex, itemElement) {
                var dxBtAfficheGrilleStrCon = $("<div/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-bars-staggered",
                    icon2: "fas fa-ellipsis",
                    colorIcone2: theme.colorBtIcon2,
                    opacityIcone2: "0.9",
                    hint: "Afficher la grille structures/contacts des clicks",
                    onClick: function (e) {
                        var xlstIdTableId = ""
                        dxVirtualGrid.mGetLstTraitementData().forEach(function (dataGrid) {
                            xlstIdTableId += ((xlstIdTableId.length > 0) ? "," : "") + dataGrid.id
                        })
                        if (xlstIdTableId.length > 0) {
                            //option.bddCtrl.mAjaxCall({ command: "getdatas", nomtable: "lst", sql: "select distinct com_destinataire.id_table_destinataire as id_table,com_destinataire.id_destinataire as id from com_email_envoi_tracking_click INNER JOIN com_destinataire ON com_email_envoi_tracking_click.id_com_destinataire=com_destinataire.id_com_destinataire where id_com_email_envoi_tracking_click in (" + xlstIdTableId + ")" }, function (data) {
                            option.bddCtrl.mAjaxCall({ command: "getdataslstemailclick", lstid: xlstIdTableId }, function (data) {
                                data.lstemailclick = JSON.parse(data.lstemailclick)
                                //if (typeof data.lstemailclick == 'undefined') data.lstemailclick = []
                                if (data.lstemailclick.length > 0) {
                                    page.mAddPopupLst("Liste des clicks emails" + ((typeof option.objet == 'undefined') ? "" : " &bull; " + option.objet), function (contentElement) {
                                        $("<div style='width:100%;height:100%;'/>").appendTo(contentElement).dxCtrlPopupLstStrConTempo({
                                            bddCtrl: option.bddCtrl,
                                            lstIdTableIdInclu: data.lstemailclick
                                        })
                                    })
                                } else { mNotify("Aucune fiche à afficher", "warning", 6000) }
                            })
                        } else { mNotify("Aucune fiche à afficher", "warning", 6000) }

                    }
                }).dxCtrlButton("instance")
                dxVirtualGrid.lstButtonForCheck.push(dxBtAfficheGrilleStrCon)

                //option.bddCtrl.mAjaxCall({ command: "getdatas", nomtable: "lst", sql: sqlGetDatas.replace("%lstid%", lstId) }, function (data) {
                //    var lstnewdossierelement = ((typeof data.lst == 'undefined') ? [] : data.lst)
                //    if (lstnewdossierelement.length > 0) {
                //        Me.objet.bddRef.getObjet("dossier").objetMetier.mAddDansDossier(e.component.element(), lstnewdossierelement)
                //    }
                //})
                ////var dxBtAddDossier = option.bddCtrl.getObjet("dossier").objetMetier.mGetButtonToolBarAddDansDossier(itemElement, function () { return dxVirtualGrid }, "select distinct com_destinataire.id_table_destinataire as id_table,com_destinataire.id_destinataire as id from com_email_envoi_tracking_click inner join (select value as id from string_split('%lstid%',',')) as tab ON com_email_envoi_tracking_click.id_com_email_envoi_tracking_click=tab.id INNER JOIN com_destinataire ON com_email_envoi_tracking_click.id_com_destinataire=com_destinataire.id_com_destinataire where not com_destinataire.id_destinataire is null")
                //if ((!dxVirtualGrid || !dxVirtualGrid.toolbarSelectIsVisible) && dxBtAddDossier) window.setTimeout(function () { dxBtAddDossier.element().closest(".dx-toolbar-button").hide() }, 0)
                //dxVirtualGrid.lstButtonForCheck.push(dxBtAddDossier)
            }
        }
        dxVirtualGrid.lstItemToolbarForCheck.push(itemToolbar)
        items.push(itemToolbar)

        if (typeof option.showBtTraitement == 'undefined' || option.showBtTraitement) {
            //if (option.bddCtrl.objCptCli.objetMetier.hasDossier()) {
            //    items.push({
            //        location: 'before',
            //        template: function (itemData, itemIndex, itemElement) {
            //            itemElement.closest(".dx-toolbar-item").css("background-color", theme.backgroundcolorBase)
            //            var dxBtAddDossier = option.bddCtrl.getObjet("dossier").objetMetier.mGetButtonToolBarAddDansDossier(itemElement, function () { return dxVirtualGrid }, "select distinct com_destinataire.id_table_destinataire as id_table,com_destinataire.id_destinataire as id from com_email_envoi_tracking_click inner join (select value as id from string_split('%lstid%',',')) as tab ON com_email_envoi_tracking_click.id_com_email_envoi_tracking_click=tab.id INNER JOIN com_destinataire ON com_email_envoi_tracking_click.id_com_destinataire=com_destinataire.id_com_destinataire where not com_destinataire.id_destinataire is null")
            //            if ((!dxVirtualGrid || !dxVirtualGrid.toolbarSelectIsVisible) && dxBtAddDossier) window.setTimeout(function () { dxBtAddDossier.element().closest(".dx-toolbar-button").hide() }, 0)
            //            dxVirtualGrid.lstButtonForCheck.push(dxBtAddDossier)
            //        }
            //    })
            //}
            //if (option.bddCtrl.objCptCli.objetMetier.hasPipeline()) {
            //    items.push({
            //        location: 'before',
            //        template: function (itemData, itemIndex, itemElement) {
            //            itemElement.closest(".dx-toolbar-item").css("background-color", theme.backgroundcolorBase)
            //            var dxBtAddPipeline = option.bddCtrl.getObjet("pipeline").objetMetier.mGetButtonToolBarAddDansPipeline(itemElement, function () { return dxVirtualGrid }, "select distinct com_destinataire.id_table_destinataire as id_table,com_destinataire.id_destinataire as id from com_email_envoi_tracking_click inner join (select value as id from string_split('%lstid%',',')) as tab ON com_email_envoi_tracking_click.id_com_email_envoi_tracking_click=tab.id INNER JOIN com_destinataire ON com_email_envoi_tracking_click.id_com_destinataire=com_destinataire.id_com_destinataire where not com_destinataire.id_destinataire is null")
            //            if ((!dxVirtualGrid || !dxVirtualGrid.toolbarSelectIsVisible) && dxBtAddPipeline) window.setTimeout(function () { dxBtAddPipeline.element().closest(".dx-toolbar-button").hide() }, 0)
            //            dxVirtualGrid.lstButtonForCheck.push(dxBtAddPipeline)
            //        }
            //    })
            //}

            //items.push({
            //    location: 'before',
            //    template: function (itemData, itemIndex, itemElement) {
            //        itemElement.closest(".dx-toolbar-item").css("background-color", theme.backgroundcolorBase)
            //        var dxBtDonwload = $("<div/>").appendTo(itemElement).dxCtrlButton({
            //            icon: "fas fa-cloud-arrow-up",
            //            txtTooltip: "Exporter la liste des contacts qui ont cliqués",
            //            onClick: function (e) {
            //                var lstDataTraitement = dxVirtualGrid.mGetLstSelectedData()
            //                if (lstDataTraitement.length == 0) lstDataTraitement = dxVirtualGrid.mGetLstData()
            //                if (lstDataTraitement.length == 0) {
            //                    mNotify("Aucune donnée à exporter.", "warning", 6000)
            //                } else {
            //                    jaugeDemarrage.mShow()
            //                    var lstIdTableId = []
            //                    lstDataTraitement.forEach(function (data) {
            //                        lstIdTableId.push({ id: data.id })
            //                    })
            //                    option.bddCtrl.mAjaxCall({
            //                        command: "exportstrconclickemail",
            //                        data: lstDataTraitement
            //                    }, function (data) {
            //                        if (data.urlfile.startsWith("~")) data.urlfile = data.urlfile.substring(1)
            //                        window.open(data.urlfile)
            //                        jaugeDemarrage.mHide()
            //                        mNotify("Votre exportation est fini. Le fichier est en cours de téléchargement.", "success", 6000)
            //                    })
            //                }
            //            }
            //        }).dxCtrlButton("instance")
            //        if ((!dxVirtualGrid || !dxVirtualGrid.toolbarSelectIsVisible) && dxBtDonwload) window.setTimeout(function () { dxBtDonwload.element().closest(".dx-toolbar-button").hide() }, 0)
            //        dxVirtualGrid.lstButtonForCheck.push(dxBtDonwload)
            //    }
            //})
        }
        return items
    }

    var conditionBaseRobot = ((option.bddCtrl.utiCourantParaJson[option.context_grid].show_robot) ? null : { nom_champ: "is_robot", ope: "=", valeur: [{ value: "0" }] })
    function mGetLstLstConditionBase() {
        if (typeof option.lstLstConditionBase != 'undefined' && option.lstLstConditionBase.length > 0) {
            if (conditionBaseRobot != null) {
                var newLstLstConditionBase = []
                var lstLstConditionBaseOption = JSON.parse(JSON.stringify(option.lstLstConditionBase))
                lstLstConditionBaseOption.forEach(function (lstConditionBaseOption) {
                    lstConditionBaseOption.push(conditionBaseRobot)
                    newLstLstConditionBase.push(lstConditionBaseOption)
                })
                return newLstLstConditionBase
            } else {
                return option.lstLstConditionBase
            }
        } else {
            return ((conditionBaseRobot == null) ? [[]] : [[conditionBaseRobot]])
        }
    }

    function mGetLstButtonLigne(toolbar, dataGrid, dataTemplate) {

    }

    this.mChangeLstIdTableIdExclu = function (lstId) {
        dxGrid.mChangeLstIdTableIdExclu(lstId)
    }
    this.mChangeLstIdTableIdInclu = function (lstId) {
        dxGrid.mChangeLstIdTableIdInclu(lstId)
    }

    this.element = function () { return container }

    mConstruit();
}